import { getAttr, getEntityId } from '../../../../features/helpers/apiHelpers';

export const mapHearingType = (translator) => (hearingType) => {
  return {
    title: getAttr(hearingType, 'name'),
    status: getAttr(hearingType, 'isActive')
      ? translator('global.active')
      : translator('global.inactive'),
    numberOfHearings: getAttr(hearingType, 'numOfHearings'),
    isInternal: getAttr(hearingType, 'isInternalHearing')
      ? translator('global.yes')
      : translator('global.no'),
    key: getEntityId(hearingType),
  };
};
